export default __webpack_public_path__ + "static/media/Events.0119b833.svg";